import { Laptop, PhoneAndroid, TabletAndroid, Tv } from "@mui/icons-material";
import {
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonGroupProps,
} from "@mui/material";
import * as React from "react";
import { useRecoilState } from "recoil";
import { USE_BREAKPOINTS } from "../hooks/useBreakpoint";
import { useSaveData } from "../hooks/useSaveData";
import { TBreakpointLabels } from "../utils/constants/hooks/breakpoints";

const ToggleBreakPoints: React.FC<ToggleButtonGroupProps> = (props) => {
  const saveData = useSaveData();
  const [breakpoint, setBreakpoint] = useRecoilState(USE_BREAKPOINTS);

  const handleBreakpoint = async (
    _event: React.MouseEvent<HTMLElement>,
    newBreakpoint: TBreakpointLabels
  ) => {
    if (newBreakpoint) {
      await saveData();

      setBreakpoint(newBreakpoint);
    }
  };

  return (
    <ToggleButtonGroup
      size="small"
      {...props}
      value={breakpoint}
      onChange={handleBreakpoint}
      aria-label="breakpoint"
      exclusive
    >
      <ToggleButton value="mobile" aria-label="mobile">
        <PhoneAndroid />
      </ToggleButton>
      <ToggleButton value="tablet" aria-label="tablet">
        <TabletAndroid />
      </ToggleButton>
      <ToggleButton value="desktop" aria-label="desktop">
        <Laptop />
      </ToggleButton>
      <ToggleButton value="all" aria-label="all">
        <Tv />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ToggleBreakPoints;
